module.exports = __webpack_public_path__ + "static/media/4.685c8602.jpg";